import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    container: {
        flex: 1,
        maxWidth: 1000,
        height: '100%',
        position: 'relative'
    },
    content: {
        height: 0,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(0, 2, 2, 2)
    },
}))